import { QuoteStatuses } from '@cpak/adp-cpak-quotes-service-models';

export const restrictCreateNewRouteForStatuses = new Set<QuoteStatuses | string>([
  QuoteStatuses.validationRequested,
  QuoteStatuses.customerApprovalRequested,
  QuoteStatuses.pricingApprovalRequested,
  QuoteStatuses.customerPriceSetup,
  QuoteStatuses.contractRequested,
  QuoteStatuses.prototypeRequested,
]);

export const pendingForPriceApprovalStatuses = new Set<QuoteStatuses | string>([
  QuoteStatuses.pricingApprovalRequested,
  QuoteStatuses.customerPriceSetup,
  QuoteStatuses.customerApprovalRequested, //this is lock for the customer approval requested status
  QuoteStatuses.validationRequested,
  QuoteStatuses.contractRequested,
  QuoteStatuses.prototypeRequested,
]);
